module.exports = __webpack_public_path__ + "static/media/Icon_ManageProjects.ae266f28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_ManageProjects.svg
// module id = 2308
// module chunks = 0